const withdraw = {
  visible: false,
  dapp: null,
  sntValue: '0',
  withdrawMax: Number.MAX_SAFE_INTEGER,
}

export default withdraw
